import "./style.css";
import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import * as dat from "lil-gui";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
setTimeout(function () {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
}, 1000);
gsap.registerPlugin(ScrollTrigger);
/**
 * Base
 */
// Debug
// const gui = new dat.GUI();

// Canvas
const canvas = document.querySelector("canvas.webgl");

// Scene
const scene = new THREE.Scene();

//Models
const gltfLoader = new GLTFLoader();
var model;
gltfLoader.load("/models/Town/scene.gltf", (gltf) => {
  gltf.scene.position.set(0, 3, 0);
  gltf.scene.scale.set(1, 1, 1);
  scene.add(gltf.scene);
  model = gltf.scene;
  // gui
  //   .add(gltf.scene.rotation, "x")
  //   .min(-Math.PI)
  //   .max(Math.PI)
  //   .step(0.0001)
  //   .name("scene rotation x");
  // gui
  //   .add(gltf.scene.rotation, "y")
  //   .min(-Math.PI)
  //   .max(Math.PI)
  //   .step(0.0001)
  //   .name("scene rotation y");
  // gui
  //   .add(gltf.scene.rotation, "z")
  //   .min(-Math.PI)
  //   .max(Math.PI)
  //   .step(0.0001)
  //   .name("scene rotation z");
  // gui
  //   .add(gltf.scene.position, "x")
  //   .min(-50)
  //   .max(50)
  //   .step(1)
  //   .name("scene position x");
  // gui
  //   .add(gltf.scene.position, "y")
  //   .min(-50)
  //   .max(50)
  //   .step(1)
  //   .name("scene position y");
  // gui
  //   .add(gltf.scene.position, "z")
  //   .min(-50)
  //   .max(50)
  //   .step(1)
  //   .name("scene position z");
});
/**
 * Floor
 */
const floor = new THREE.Mesh(
  new THREE.PlaneGeometry(10, 10),
  new THREE.MeshStandardMaterial({
    color: "#444444",
    metalness: 0,
    roughness: 0.5,
  })
);
floor.receiveShadow = true;
floor.rotation.x = -Math.PI * 0.5;
// scene.add(floor);

/**
 * Lights
 */
const ambientLight = new THREE.AmbientLight(0xffffff, 1.5);
scene.add(ambientLight);

const directionalLight = new THREE.DirectionalLight(0xffffff, 0.6);
directionalLight.castShadow = true;
directionalLight.shadow.mapSize.set(1024, 1024);
directionalLight.shadow.camera.far = 15;
directionalLight.shadow.camera.left = -7;
directionalLight.shadow.camera.top = 7;
directionalLight.shadow.camera.right = 7;
directionalLight.shadow.camera.bottom = -7;
directionalLight.position.set(5, 5, 5);
scene.add(directionalLight);

/**
 * Sizes
 */
const sizes = {
  width: window.innerWidth,
  height: window.innerHeight,
};

window.addEventListener("resize", () => {
  // Update sizes
  sizes.width = window.innerWidth;
  sizes.height = window.innerHeight;

  // Update camera
  camera.aspect = sizes.width / sizes.height;
  camera.updateProjectionMatrix();

  // Update renderer
  renderer.setSize(sizes.width, sizes.height);
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
});

/**
 * Camera
 */
const cameraGroup = new THREE.Group();
// Base camera
scene.add(cameraGroup);
const camera = new THREE.PerspectiveCamera(
  75,
  sizes.width / sizes.height,
  0.1,
  300
);
camera.position.set = (0, 3, 0);
camera.lookAt(0, 0, 0);
cameraGroup.add(camera);
// gui
//   .add(camera.position, "x")
//   .min(-Math.PI)
//   .max(Math.PI)
//   .step(0.0001)
//   .name("camera position x");
// gui
//   .add(camera.position, "y")
//   .min(-Math.PI)
//   .max(Math.PI)
//   .step(0.0001)
//   .name("camera position y");
// gui
//   .add(camera.position, "z")
//   .min(-Math.PI)
//   .max(Math.PI)
//   .step(0.0001)
//   .name("camera position z");
// gui
//   .add(camera.rotation, "x")
//   .min(-Math.PI)
//   .max(Math.PI)
//   .step(1)
//   .name("camera rotation x");
// gui
//   .add(camera.rotation, "y")
//   .min(-Math.PI)
//   .max(Math.PI)
//   .step(1)
//   .name("camera rotation y");
// gui
//   .add(camera.rotation, "z")
//   .min(-Math.PI)
//   .max(Math.PI)
//   .step(1)
//   .name("camera rotation z");
const viewModal = document.querySelector(".viewModal");
const secondStep = document.querySelector(".secondStep");
const thirdStep = document.querySelector(".thirdStep");
const fourthStep = document.querySelector(".fourthStep");
const hello = document.querySelector(".storyMain h1");
console.log(hello);
setTimeout(function () {
  gsap
    .timeline({
      scrollTrigger: {
        trigger: viewModal,
        start: "top top",
        end: "bottom 50%",
        scrub: 2,
      },
    })
    .to(camera.position, { x: 0, y: -30, z: 20, duration: 3 })
    .to(camera.position, { x: 0, y: 0, z: 30, duration: 3 })
    .to(model.position, { x: 0, y: -1, z: 16, duration: 3 })
    .to(camera.position, { z: 23, duration: 5 })
    .to(model.position, { x: -2, duration: 5 }, "<")
    .to(camera.position, { z: 17, duration: 5 })
    .to(model.position, { x: 2, duration: 5 }, "<")
    .to(camera.position, { z: 14, duration: 5 })
    .to(model.position, { x: -2, duration: 5 }, "<")
    .to(camera.position, { z: 10, duration: 5 })
    .to(model.position, { x: 2, duration: 5 }, "<")
    .to(camera.position, { z: 2, duration: 5 })
    .to(model.position, { x: 0, duration: 5 }, "<")
    .to(camera.position, { x: -2, duration: 3 })
    .to(camera.position, { y: 0.129, duration: 3 }, "<")
    .to(camera.position, { z: 0.129, duration: 3 }, "<")
    .to(model.position, { x: -10, duration: 3 })
    .to(camera.position, { x: -0.2224, duration: 3 })
    .to(camera.position, { y: 0.6614, duration: 3 }, "<")
    .to(camera.position, { z: -1.2604, duration: 3 }, "<")
    .to(model.position, { z: -8, duration: 3 })
    .to(camera.position, { x: 1.2659, duration: 3 })
    .to(camera.position, { y: 0.6614, duration: 3 }, "<")
    .to(camera.position, { z: -0.0247, duration: 3 }, "<")
    .to(model.position, { x: 0, duration: 3 })
    .to(camera.position, { x: -0.0247, y: 0.7475, z: 1.8287, duration: 3 });
  // .to(camera.position, { z: 20 })
  // .to(camera.position, { z: 15 })
  // .to(camera.position, { z: 10 })
  // .to(camera.position, { z: 5 })
  // .to(camera.position, { z: 0 }, "<")
  // .to(camera.position, { x: -2, y: 0, z: 0 })
  // .to(model.position, { x: -10 });

  // gsap
  //   .timeline({
  //     scrollTrigger: {
  //       trigger: secondStep,
  //       start: "top top",
  //       end: "bottom 50%",
  //       scrub: 2,
  //     },
  //   })

  // gsap.timeline({
  //   scrollTrigger: {
  //     trigger: thirdStep,
  //     start: "top top",
  //     end: "bottom 50%",
  //     scrub: 2,
  //   },
  // });

  // gsap.timeline({
  //   scrollTrigger: {
  //     trigger: fourthStep,
  //     start: "top top",
  //     end: "bottom 50%",
  //     scrub: 2,
  //   },
  // });
}, 2000);
const camerahelper = new THREE.CameraHelper(camera);
// scene.add(camerahelper);
const axeshelper = new THREE.AxesHelper(3);
// scene.add(axeshelper);

// Controls
const controls = new OrbitControls(camera, canvas);
controls.target.set(0, 0.75, 0);
controls.enableDamping = true;

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
  canvas: canvas,
});
renderer.shadowMap.enabled = true;
renderer.shadowMap.type = THREE.PCFSoftShadowMap;
renderer.setSize(sizes.width, sizes.height);
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
/**
 * Cursor
 */
var scrollAnimation = false;
var moveslower = false;

window.addEventListener("scroll", () => {
  var top = window.pageYOffset || document.documentElement.scrollTop;
  console.log(top);
  if (top > 3000) {
    scrollAnimation = true;
    moveslower = true;
  } else {
    scrollAnimation = false;
  }
  if (top > 13811) {
    moveslower = false;
  }
  console.log(scrollAnimation);
});
const cursor = {};
cursor.x = 0;
cursor.y = 0;

window.addEventListener("mousemove", (event) => {
  cursor.x = event.clientX / sizes.width - 0.5;
  cursor.y = event.clientY / sizes.height - 0.5;
});
/**
 * Animate
 */

const clock = new THREE.Clock();
let previousTime = 0;
const tick = () => {
  const elapsedTime = clock.getElapsedTime();
  const deltaTime = elapsedTime - previousTime;
  previousTime = elapsedTime;
  var amountToMovex = 0;
  var amountToMovey = 0;
  if (scrollAnimation) {
    if (moveslower) {
      amountToMovex = 0.5;
      amountToMovey = 0.5;
    } else {
      amountToMovex = 0.2;
      amountToMovey = 0.2;
    }
    const parallaxX = cursor.x * amountToMovex;
    const parallaxY = -cursor.y * amountToMovey;
    cameraGroup.position.x +=
      (parallaxX - cameraGroup.position.x) * 3 * deltaTime;
    cameraGroup.position.y +=
      (parallaxY - cameraGroup.position.y) * 3 * deltaTime;
  }

  // Update controls
  controls.update();

  // Render
  renderer.render(scene, camera);

  // Call tick again on the next frame
  window.requestAnimationFrame(tick);
};

tick();
